var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '../../components';
import { classNames, renderIcon } from '../../utils';
import * as styles from './icon-title-description-tile.styles';
export var IconTitleDescriptionTile = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, icon = _a.icon, _b = _a.iconColour, iconColour = _b === void 0 ? 'white' : _b, _c = _a.iconBorderColour, iconBorderColour = _c === void 0 ? 'tertiary' : _c, className = _a.className;
    return (_jsxs("div", __assign({ className: classNames(styles.wrapper, className) }, { children: [_jsx("div", __assign({ className: 'mr-4' }, { children: _jsx("div", __assign({ className: classNames(styles.iconWrapper, "bg-".concat(iconBorderColour)) }, { children: renderIcon(icon, "w-5 h-5 text-".concat(iconColour)) })) })), _jsxs("div", { children: [_jsx(Typography, { color: 'textDark', type: 'small', weight: 'bold', text: title }), _jsx(Typography, { color: 'textMid', type: 'help', weight: 'normal', text: subTitle })] })] })));
};
export default IconTitleDescriptionTile;
//# sourceMappingURL=icon-title-description-tile.js.map